import React from 'react';

const Index = () => (
  <div className="loaders-container">
    <div className="container">
      <div className="box"></div>
    </div>
  </div>
)

export default Index;


// WEBPACK FOOTER //
// ./src/components/Loading.js